export const CandidateRouteParameters = {
  CandidateId: 'candidateId',
  MessageId: 'messageId',
} as const;
